import { Form, Input, InputNumber } from 'antd';
import { useState } from 'react';
import { apiClient, apiErrorMessage } from '../../../utils';
import { CustomerClass } from '../../../models/index';
import { ConfirmGroupButton } from '../../../elements/confim-group-button';

export function CustomerClassEditPage(props: {
  customerClass?: CustomerClass;
  onSaved: (customerClass?: CustomerClass) => void;
  onCancel: () => void;
}) {
  const [loading, setLoading] = useState(false);

  const formValues: any = {
    ...props.customerClass,
  };

  const onFinish = (values: any) => {
    setLoading(true);
    if (!props.customerClass) {
      apiClient
        .post('customer-classes', values)
        .then(() => {
          props.onSaved();
        })
        .catch((reason: any) => {
          apiErrorMessage(reason);
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      apiClient
        .put(`customer-classes/${props.customerClass?.id}`, values)
        .then((response: any) => {
          props.onSaved(response.data);
        })
        .catch((reason: any) => {
          apiErrorMessage(reason);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  return (
    <Form layout="vertical" name="basic" onFinish={onFinish} initialValues={formValues}>
      <Form.Item
        label="İsim"
        name="name"
        rules={[
          { required: true, message: 'Zorunlu alan' },
          { max: 200, message: 'En fazla 200 karakter' },
        ]}
      >
        <Input />
      </Form.Item>

      <Form.Item label="Öncelik puanı" name="priorityScore" rules={[{ required: true, message: 'Zorunlu alan' }]}>
        <InputNumber min={0} style={{ width: '100%' }} />
      </Form.Item>

      <Form.Item>
        <ConfirmGroupButton onCancel={props.onCancel} loading={loading} />
      </Form.Item>
    </Form>
  );
}
